import { MessageCircleQuestion, NotebookPen, Store, EyeOff } from "lucide-react";
import { STR } from "@/data/i18n";
import { useLang } from "@/lib/lang";
import { FadeUp, SectionHeading } from "./Shared";

const ICONS = [MessageCircleQuestion, NotebookPen, Store, EyeOff];

export const Problems = () => {
    const { lang } = useLang();
    const t = STR.problems[lang];

    return (
        <section id="masalah" data-testid="problems-section" className="relative py-24 md:py-32">
            <div className="mx-auto max-w-7xl px-5 md:px-8">
                <SectionHeading eyebrow={t.eyebrow} title={t.title} subtitle={t.subtitle} />
                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
                    {t.cards.map(({ title, desc }, i) => {
                        const Icon = ICONS[i];
                        return (
                            <FadeUp key={title} delay={i * 0.1}>
                                <article
                                    data-testid={`problem-card-${i + 1}`}
                                    className="card-surface group h-full p-8 transition-[transform,border-color] duration-300 hover:-translate-y-2 hover:border-amber-400/30"
                                >
                                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-red-600/20 to-amber-500/20 text-amber-400 transition-colors duration-300 group-hover:text-amber-300">
                                        <Icon className="h-6 w-6" />
                                    </div>
                                    <h3 className="mt-6 text-lg font-semibold text-slate-50">{title}</h3>
                                    <p className="mt-3 text-sm leading-relaxed text-zinc-400">{desc}</p>
                                </article>
                            </FadeUp>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
